import type { ReactNode } from 'react';
import { cn } from '../cn';

/**
 * Лоадер приложения (решение пользователя 2026-10-16): 12 рисок по кругу шагами, цвет — текущий цвет текста, размер —
 * 1em, поэтому встаёт к любой надписи и в любую кнопку. Рисунок — .nd-spinner в newdesign.css. Для чтеца скрыт:
 * что грузится, говорит надпись рядом (Loading) или кнопка (Button loading).
 */
export function Spinner({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cn('nd-spinner', className)} />;
}

/** «Загружаем задачи…» с лоадером слева — везде, где ждём данные */
export function Loading({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span role="status" className={cn('nd:inline-flex nd:items-center nd:gap-2', className)}>
      <Spinner />
      {children}
    </span>
  );
}
